import { createAsyncThunk } from "@reduxjs/toolkit";
import { timeSeriesChartService } from "_services";

export const getTimeSeriesChartAction = createAsyncThunk(
    'healthdata/getTimeSeriesChartData',
    async ({ chargeboxId, chartDataName, timeGrainOption, dates, auth0Token }) =>
        await timeSeriesChartService.getTimeSeriesChartData(chargeboxId, chartDataName, timeGrainOption, dates, auth0Token)
);